const prodConfig = {
    BaseRequestUrl: 'https://api.th-digitaltwin.com.hk',
    LoginSuccessRedirect: 'https://www.th-digitaltwin.com.hk'
};

export const WebSiteConfig = {
    ...prodConfig,
};

export const TokenLocalStorageKey = 'sso-admin-token';

export const NotAuthPages = ['/', '/permission', '/Atal', '/atal'];